export function redirectToConsole(): void {
  window.location.href = '/mc/';
}
